import React, { FC } from "react";

import i18n from "core/i18n";
import { ContractChangesTab } from "containers/contract";

import { changesDefinition } from "../changesDefinition";

export const ChangesTab: FC = () => {
    const { t } = i18n.useTranslation();
    return <ContractChangesTab changesDefinition={changesDefinition(t)} />;
};
